import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConnectorService } from 'src/app/core/services/connector.service';
import { MetadataLoadingStage, UserContextService } from 'src/app/core/services/user-context.service';
import { SharedService } from 'src/app/core/services/shared-service';
import { HotGlueComponent } from 'src/app/shared/hot-glue/hot-glue.component';

@Component({
  selector: 'app-connector',
  templateUrl: './connector.component.html',
  styleUrl: './connector.component.css'
})
export class ConnectorComponent implements OnInit {
  @ViewChild(HotGlueComponent) hotGlueComponent!: HotGlueComponent;

  isLoading = true;
  isScriptLoaded = false;

  constructor(
    private hotGlueService: ConnectorService,
    private router: Router,
    public userContextService: UserContextService,
    private sharedService: SharedService
  ) {}

  async ngOnInit(): Promise<void> {
    let subLoadingAttempts = 20;
    while (this.userContextService.MetadataLoadingStage < MetadataLoadingStage.SubscriptionsLoaded && subLoadingAttempts > 0) {
      await this.userContextService.LoadMetaData(null,null,false);
      // Set a 5 second timer to simulate loading
      if (this.userContextService.MetadataLoadingStage >= MetadataLoadingStage.SubscriptionsLoaded) {
        break;
      } else {
        await new Promise(resolve => setTimeout(resolve, 250)); // Proper async delay
        subLoadingAttempts--;
      }
    }

    if (this.userContextService.MetadataLoadingStage < MetadataLoadingStage.SubscriptionsLoaded) {
      this.sharedService.NoAccessMessage = 'Looks like something went wrong on our end. We are trying our hardest to resolve the issue. Please check back later.'
      this.sharedService.AccessDenied = true;
    }

    if (this.userContextService.MetadataLoadingStage < MetadataLoadingStage.InstanceMetadataLoaded) {
      console.log('Pending instance not found, attempting to load...');
      let count = 20;
      let pendingInstance = await this.userContextService.LoadPendingInstance();
      console.log('Pending instance:', pendingInstance);

      while (!pendingInstance && count > 0) {
        console.log(`Attempt number: + ${(20 - count + 1)}`);
        // Set a 5 second timer to simulate loading
        await new Promise(resolve => setTimeout(resolve, 5000)); // Proper async delay
        pendingInstance = await this.userContextService.LoadPendingInstance();
        count--;
      }
      // Timeout after 100 seconds
      if (!pendingInstance && count === 0) {
        this.sharedService.NoAccessMessage = 'Looks like something went wrong on our end. We are trying our hardest to resolve the issue. Please check back later.'
        this.sharedService.AccessDenied = true;
      }
    }


    this.isLoading = false;
  }

  onScriptLoaded(): void {
    this.setListeners();
  }

  private setListeners(): void {
    if (this.hotGlueComponent) {
      this.hotGlueComponent.SetOnSourceLinkedListener((source, flowID) => {
        this.sharedService.DisplayNotification('Source linked successfully', 'success');
        this.router.navigate(['/onboarding/completed']);
      });

      this.hotGlueComponent.SetonSourceLinkCanceled((tap, flow_id) => {
        this.hotGlueService.HotGlue.close();
      });

      this.hotGlueComponent.SetOnSourceUnlinkedListener((tap, flow_id) => {
        this.hotGlueService.HotGlue.close();
      });

      this.hotGlueComponent.SetOnCloseListener((tap, flow_id) => { 
        this.hotGlueService.HotGlue.close();
      });
    }
  }
}
